import { render } from "./NavigationComp.vue?vue&type=template&id=18f18dd2"
import script from "./NavigationComp.vue?vue&type=script&lang=js"
export * from "./NavigationComp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__